import React, { useEffect } from 'react';

import queryString from 'query-string';
import { Outlet, useLocation, useNavigate } from 'react-router-dom';

import { FullScreenLoader } from '@packages/components/loader/full-screen-loader';
import { STORAGE_KEYS } from 'ae-constants/constants';
import { ORGANIZATION_SWITCH_ROUTE } from 'ae-constants/routes.constants';
import { useSelectedOrganizationContext } from 'ae-kernel/selected-organization-provider';

function savePreviousPageUrl(pathname: string, search: string): void {
  const searchParams = queryString.parse(search);

  const filteredSearchParams = Object.fromEntries(
    Object.entries(searchParams).filter(
      ([key]) => !['org', 'code', 'state'].includes(key),
    ),
  );

  window.localStorage.setItem(
    STORAGE_KEYS.AWN_PREVIOUS_PAGE_URL,
    `${pathname}?${queryString.stringify(filteredSearchParams)}`,
  );
}

export const RequireSelectedOrganizationGuard: React.FC = () => {
  const selectedOrganizationCtx = useSelectedOrganizationContext();

  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    if (!selectedOrganizationCtx.selectedOrganization?.id) {
      savePreviousPageUrl(location.pathname, location.search);

      navigate(ORGANIZATION_SWITCH_ROUTE);
    }
  }, [
    location.pathname,
    location.search,
    navigate,
    selectedOrganizationCtx.selectedOrganization?.id,
  ]);

  return selectedOrganizationCtx.selectedOrganization?.id ? (
    <Outlet />
  ) : (
    <FullScreenLoader />
  );
};
